import { GJS_PRODUCTS_SEPARATOR } from 'config/constants';

export const parseCatnums = (text: string): string[] => {
    const dividedText = text.split(GJS_PRODUCTS_SEPARATOR).filter(Boolean);
    const productsRegex = new RegExp(/\[gjc-comp-ProductList&#61;(.+)]/g);
    const productsCatnum: string[] = [];

    dividedText.forEach((textPart) => {
        const products = productsRegex.exec(textPart);
        if (products !== null) {
            productsCatnum.push(...products[1].split(','));
        }
    });

    return productsCatnum;
};
